import { Component } from '@verndale/core';
import '../../scss/modules/_accordion-list.scss';

class AccordionList extends Component {
  private viewMoreData: string;
  private isOpen: boolean;
  private clicked: boolean;

  constructor(el: HTMLElement) {
    super(el);
    this.viewMoreData = this.el.dataset.viewMore || '';
    this.isOpen = this.el.dataset.isOpen === 'true';
    this.clicked = false;
  }

  setupDefaults() {
    this.dom = {
      accordionBtn: this.el.querySelector<HTMLElement>('.accordion__button'),
      accordionContent: this.el.querySelector<HTMLElement>('.accordion__content-container'),
      minusIcon: this.el.querySelector<HTMLElement>('.accordion__button__icon--minus'),
      plusIcon: this.el.querySelector<HTMLElement>('.accordion__button__icon--plus'),
      viewMoreBtn: this.el.querySelector<HTMLElement>('.accordion__read-more-button'),
      viewMoreContainer: this.el.querySelector<HTMLElement>('.accordion__read-more')
    };

    this.viewMoreData = this.el.dataset.viewMore || '';
    this.isOpen = this.el.dataset.isOpen === 'true';
    this.clicked = false;

    if (!this.viewMoreData) {
      (this.dom.viewMoreContainer as HTMLElement).remove();
    }
  }

  addListeners() {
    (this.dom.accordionBtn as HTMLElement).addEventListener(
      'click',
      this.toggleAccordion.bind(this)
    );

    if (this.viewMoreData && this.dom.viewMoreBtn) {
      (this.dom.viewMoreBtn as HTMLElement).addEventListener(
        'click',
        this.toggleViewMore.bind(this)
      );
    }

    if (this.isOpen) {
      (this.dom.accordionContent as HTMLElement).removeAttribute('hidden');
      (this.dom.accordionBtn as HTMLElement).setAttribute('aria-expanded', 'true');
      (this.dom.minusIcon as HTMLElement).removeAttribute('hidden');
      (this.dom.plusIcon as HTMLElement).setAttribute('hidden', 'true');
      (this.dom.accordionContent as HTMLElement).classList.add(
        'accordion__content-container--restricted-view'
      );
      this.checkContent();
    }
  }

  checkContent() {
    const description = this.el.querySelector('.accordion__content-description') as HTMLElement;
    if (!description) return;

    const descriptionHeight = description.offsetHeight;
    (this.dom.accordionContent as HTMLElement).style.maxBlockSize = `${descriptionHeight * 0.5}px`;
  }

  toggleViewMore() {
    if (
      (this.dom.accordionContent as HTMLElement).classList.contains(
        'accordion__content-container--restricted-view'
      )
    ) {
      (this.dom.viewMoreContainer as HTMLElement).remove();
      (this.dom.accordionContent as HTMLElement).removeAttribute('style');
      (this.dom.viewMoreContainer as HTMLElement).removeAttribute('style');
      (this.dom.accordionContent as HTMLElement).classList.remove(
        'accordion__content-container--restricted-view'
      );
      this.clicked = true;
    }
  }

  toggleAccordion() {
    if ((this.dom.accordionContent as HTMLElement).hidden) {
      (this.dom.accordionContent as HTMLElement).removeAttribute('hidden');
      (this.dom.accordionBtn as HTMLElement).setAttribute('aria-expanded', 'true');
      (this.dom.minusIcon as HTMLElement).removeAttribute('hidden');
      (this.dom.plusIcon as HTMLElement).setAttribute('hidden', 'true');

      if (this.viewMoreData && !this.clicked) {
        (this.dom.accordionContent as HTMLElement).classList.add(
          'accordion__content-container--restricted-view'
        );

        this.checkContent();
      }
    } else {
      (this.dom.accordionContent as HTMLElement).setAttribute('hidden', 'true');
      (this.dom.accordionBtn as HTMLElement).setAttribute('aria-expanded', 'false');
      (this.dom.minusIcon as HTMLElement).setAttribute('hidden', 'true');
      (this.dom.plusIcon as HTMLElement).removeAttribute('hidden');
    }
  }
}

export default AccordionList;
